import Vue from 'vue'
import Router from 'vue-router'

//import soccerMatches from '@/views/matches/soccer/index'
const soccerMatches = resolve => require(['@/views/matches/soccer/index'], resolve);
//import basketMatches from '@/views/matches/basket/index'
const basketMatches = resolve => require(['@/views/matches/basket/index'], resolve);
//import teamPage from '@/views/team/soccer/indexPage'
const teamPage = resolve => require(['@/views/team/soccer/indexPage'], resolve);

//import score from '@/views/score/index'
const score = resolve => require(['@/views/score/index'], resolve);

//import newsListPage from '@/views/news/listPage'
const newsListPage = resolve => require(['@/views/news/listPage'], resolve);

//import playerPage from '@/views/player/soccer/player'
const playerPage = resolve => require(['@/views/player/soccer/player'], resolve);

//import basketPlayerPage from '@/views/player/basket/player'
const basketPlayerPage = resolve => require(['@/views/player/basket/player'], resolve);

//import lineupPage from '@/views/soccer/lineupPage'
const lineupPage = resolve => require(['@/views/soccer/lineupPage'], resolve);

//import matchEventPage from '@/views/soccer/matchEventPage'
const matchEventPage = resolve => require(['@/views/soccer/matchEventPage'], resolve);

//import statisticsPage from '@/views/soccer/statisticsPage'
const statisticsPage = resolve => require(['@/views/soccer/statisticsPage'], resolve);

//import livePage from '@/views/soccer/livePage'
const livePage = resolve => require(['@/views/soccer/livePage'], resolve);

//import prospectPage from '@/views/soccer/prospectPage'
const prospectPage = resolve => require(['@/views/soccer/prospectPage'], resolve);

//import basketStatisticsPage from '@/views/basket/statisticsPage'
const basketStatisticsPage = resolve => require(['@/views/basket/statisticsPage'], resolve);

//import y30Page from '@/views/y30/y30'
const y30Page = resolve => require(['@/views/y30/y30'], resolve);

//import basketLivePage from '@/views/basket/livePage'
const basketLivePage = resolve => require(['@/views/basket/livePage'], resolve);

//import basketProspectPage from '@/views/basket/prospectPage'
const basketProspectPage = resolve => require(['@/views/basket/prospectPage'], resolve);

//import basketContrastPage from '@/views/basket/contrastPage'
const basketContrastPage = resolve => require(['@/views/basket/contrastPage'], resolve);

//import basketTeamPage from '@/views/team/basket/indexPage'
const basketTeamPage = resolve => require(['@/views/team/basket/indexPage'], resolve);

const askIndexPage = resolve => require(['@/views/ask/index'], resolve);
const askRoomPage = resolve => require(['@/views/ask/room/room'], resolve);
const askUserPage = resolve => require(['@/views/ask/user'], resolve);
const askHistoryPage = resolve => require(['@/views/ask/history'], resolve);
/*const askRecordPage = resolve => require(['@/views/ask/record'], resolve);*/
const askRevivePage = resolve => require(['@/views/ask/revive'], resolve);
const askRankingPage = resolve => require(['@/views/ask/ranking'], resolve);
const askNewsPage = resolve => require(['@/views/ask/news'], resolve);
const askPersonalPage = resolve => require(['@/views/ask/personal'], resolve);
const askCandidatePage = resolve => require(['@/views/ask/candidate'], resolve);

const maximumPage = resolve => require(['@/views/soccerBigData/maximum'], resolve);
const hotSoccerMatchesPage = resolve => require(['@/views/soccerBigData/hot'], resolve);
const dataServicePage = resolve => require(['@/views/soccerBigData/dataService'], resolve);

/*const askRulesPage = resolve => require(['@/views/ask/rules'], resolve);*/
const qualifyingPage = resolve => require(['@/views/qualifying/index'], resolve);
const qualifyingListPage = resolve => require(['@/views/qualifying/list'], resolve);
const qualifyingPersonalPage=resolve => require(['@/views/qualifying/personal'], resolve);
const qualifyingRankPage=resolve => require(['@/views/qualifying/rank'], resolve);
const militaryRankPage=resolve => require(['@/views/qualifying/militaryRank'], resolve);
const findPage=resolve => require(['@/views/find/index'], resolve);
const matchInfoPage=resolve => require(['@/views/find/matchInfo'], resolve);
const matchInfoPage2=resolve => require(['@/views/find/matchInfo2'], resolve);
const shopPage=resolve => require(['@/views/shop/index'], resolve);
const shopDetailPage=resolve => require(['@/views/shop/detail'], resolve);
const shopShareDetailPage=resolve => require(['@/views/shop/shareDetail'], resolve);
const shopOrderPage=resolve => require(['@/views/shop/order'], resolve);
const shopOrderListPage=resolve => require(['@/views/shop/orderList'], resolve);
const shopSearchPage=resolve => require(['@/views/shop/shopSearch'], resolve);
const hotMatchPage=resolve => require(['@/views/find/hotMatch'], resolve);
const infoListPage=resolve => require(['@/views/info/infoList'], resolve);
const infoExpertPage=resolve => require(['@/views/info/expert'], resolve);
const infoApplyPage=resolve => require(['@/views/info/apply'], resolve);
const myLevelPage=resolve => require(['@/views/info/myLevel'], resolve);
const myIncomePage=resolve => require(['@/views/info/myIncome'], resolve);
const incomeDetailPage=resolve => require(['@/views/info/incomeDetail'], resolve);
const infoConditionPage=resolve => require(['@/views/info/condition'], resolve);
const titanNewspapersPage = (resolve) =>
  require(["@/views/titanNewspapers/titanNewspapers"], resolve);
Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: "/matches/soccer/:lid",
      name: "soccerMatches",
      component: soccerMatches,
    },
    {
      path: "/matches/basket/:lid",
      name: "basketMatches",
      component: basketMatches,
    },
    /*{
      path: '/team/:sport/:tid',
      name: 'teamPage',
      component:teamPage,
      meta: {title: "球队详情"}
    },*/
    {
      path: "/team/soccer/:tid",
      name: "teamPage",
      component: teamPage,
      meta: { title: "球队详情" },
    },
    {
      path: "/team/basket/:tid",
      name: "teamPage",
      component: basketTeamPage,
      meta: { title: "球队详情" },
    },
    //新闻列表
    {
      path: "/news/list",
      name: "newsListPage",
      component: newsListPage,
    },
    //球员详情
    {
      path: "/player/soccer/:id",
      name: "playerData",
      component: playerPage,
      meta: { title: "球员详情" },
    },
    {
      path: "/player/basket/:id",
      name: "playerData",
      component: basketPlayerPage,
      meta: { title: "球员详情" },
    },
    //app足球比赛详情页中的赛况
    {
      path: "/soccer/outs/:id",
      name: "soccerOuts",
      component: (resolve) => require(["@/views/soccer/outs/index"], resolve),
      meta: { title: "赛况" },
    },
    //app足球比赛详情页中的分析
    {
      path: "/soccer/analysis/:id",
      name: "soccerAnalysis",
      component: (resolve) =>
        require(["@/views/soccer/analysis/index"], resolve),
      meta: { title: "分析" },
    },
    //足球前瞻
    {
      path: "/soccer/prospect/:id",
      name: "prospect",
      component: prospectPage,
    },
    //足球文字直播
    {
      path: "/soccer/live/:id",
      name: "live",
      component: livePage,
    },
    //足球阵容
    {
      path: "/soccer/lineup/:id",
      name: "lineup",
      component: lineupPage,
    },
    //足球事件
    {
      path: "/soccer/event/:id",
      name: "event",
      component: matchEventPage,
    },
    //足球技术统计
    {
      path: "/soccer/statistics/:id",
      name: "statistics",
      component: statisticsPage,
    },
    {
      path: "/y30",
      name: "y30Page",
      component: y30Page,
      meta: { title: "体坛30周年" },
    },
    //篮球统计
    {
      path: "/basket/statistics/:id",
      name: "basketStatisticsPage",
      component: basketStatisticsPage,
    },
    //篮球文字直播
    {
      path: "/basket/live/:id",
      name: "live",
      component: basketLivePage,
    },
    //篮球战绩
    {
      path: "/basket/prospect/:id",
      name: "basketProspect",
      component: basketProspectPage,
    },
    //篮球对比
    {
      path: "/basket/contrast/:id",
      name: "basketContrastPage",
      component: basketContrastPage,
    },

    {
      path: "/score",
      name: "score",
      component: score,
    },

    {
      path: "/ask/index",
      name: "askIndex",
      component: askIndexPage,
      meta: {
        title: "体坛预测王",
        description: "快来参加体坛预测王，终极大奖等您来领",
      },
    },
    {
      path: "/ask/room/:id",
      name: "askRoom",
      component: askRoomPage,
      meta: {
        title: "体坛预测王",
        description: "快来参加体坛预测王，终极大奖等您来领",
      },
    },
    {
      path: "/ask/user/:subjectId",
      name: "askUser",
      component: askUserPage,
      meta: {
        title: "体坛预测王",
        description: "快来参加体坛预测王，终极大奖等您来领",
      },
    },
    {
      path: "/ask/history/:id",
      name: "askHistory",
      component: askHistoryPage,
      meta: {
        title: "体坛预测王",
        description: "快来参加体坛预测王，终极大奖等您来领",
      },
    },
    /* {
      path: '/ask/record',
      name: 'askRecord',
      component: askRecordPage,
      meta: {title: "体坛预测王", description: '快来参加体坛预测王，终极大奖等您来领'}
    },*/
    {
      path: "/ask/revive",
      name: "askRevive",
      component: askRevivePage,
      meta: {
        title: "体坛预测王",
        description: "快来参加体坛预测王，终极大奖等您来领",
      },
    },
    {
      path: "/ask/ranking",
      name: "askRanking",
      component: askRankingPage,
      meta: {
        title: "体坛预测王",
        description: "快来参加体坛预测王，终极大奖等您来领",
      },
    },
    {
      path: "/ask/news",
      name: "askNews",
      component: askNewsPage,
      meta: {
        title: "体坛预测王",
        description: "快来参加体坛预测王，终极大奖等您来领",
      },
    },
    {
      path: "/ask/personal/:id",
      name: "askPersonal",
      component: askPersonalPage,
      meta: {
        title: "体坛预测王",
        description: "快来参加体坛预测王，终极大奖等您来领",
      },
    },
    {
      path: "/ask/candidate/:id",
      name: "askCandidate",
      component: askCandidatePage,
      meta: {
        title: "体坛预测王",
        description: "快来参加体坛预测王，终极大奖等您来领",
      },
    },

    /*{
      path: '/ask/rules',
      name: 'askRules',
      component: askRulesPage,
      meta: {title: "竞赛规则", description: '快来参加体坛预测王，终极大奖等您来领'}
    }*/
    {
      path: "/maximum",
      name: "maximum",
      component: maximumPage,
      meta: { title: "极限", description: "极限" },
    },
    {
      path: "/hotSoccer",
      name: "hotSoccer",
      component: hotSoccerMatchesPage,
      meta: { title: "大热", description: "大热" },
    },
    {
      path: "/dataService/info/:matchID",
      name: "matchInfo",
      component: matchInfoPage,
      meta: { title: "赛事情报", description: "体坛数据服务" },
    },
    {
      path: "/dataService/:type",
      name: "dataService",
      component: dataServicePage,
      meta: { title: "体坛数据服务", description: "体坛数据服务" },
    },
    {
      path: "/dService/liSan",
      name: "dServiceLiSan",
      component: (resolve) => require(["@/views/soccerBigData/liSan"], resolve),
      meta: { title: "离散", description: "离散" },
    },
    {
      path: "/dService/biLi",
      name: "dServiceBiLi",
      component: (resolve) => require(["@/views/soccerBigData/biLi"], resolve),
      meta: { title: "比例", description: "比例" },
    },

    {
      path: "/qualifying/index",
      name: "qualifying",
      component: qualifyingPage,
      meta: {
        title: "预测王·升级赛",
        description: "高额奖池等待高手瓜分，不服来战",
      },
    },
    {
      path: "/qualifying/list",
      name: "qualifyingList",
      component: qualifyingListPage,
      meta: {
        title: "预测王·升级赛",
        description: "高额奖池等待高手瓜分，不服来战",
      },
    },
    {
      path: "/qualifying/personal/:uid",
      name: "qualifyingPersonal",
      component: qualifyingPersonalPage,
      meta: {
        title: "预测王·升级赛",
        description: "高额奖池等待高手瓜分，不服来战",
      },
    },
    {
      path: "/qualifying/rank",
      name: "qualifyingRank",
      component: qualifyingRankPage,
      meta: {
        title: "预测王·升级赛",
        description: "高额奖池等待高手瓜分，不服来战",
      },
    },

    {
      path: "/qualifying/military",
      name: "qualifyingMilitary",
      component: militaryRankPage,
      meta: {
        title: "预测王·升级赛",
        description: "高额奖池等待高手瓜分，不服来战",
      },
    },
    {
      path: "/find",
      name: "find",
      component: findPage,
      meta: { title: "情报", description: "情报" },
    },
    {
      path: "/find/matchInfo",
      name: "matchInfo2",
      component: matchInfoPage2,
      meta: { title: "赛事情报站", description: "赛事情报站" },
    },
    {
      path: "/hotMatch",
      name: "hotMatch",
      component: hotMatchPage,
      meta: { title: "热门赛事", description: "热门赛事" },
    },
    {
      path: "/info/list",
      name: "infoList",
      component: infoListPage,
      meta: { title: "情报", description: "情报" },
    },
    {
      path: "/info/expert",
      name: "infoExpert",
      component: infoExpertPage,
      meta: { title: "情报专家", description: "情报专家" },
    },
    {
      path: "/info/expertTj",
      name: "infoExpertTj",
      component: (resolve) => require(["@/views/info/infoExpertTj"], resolve),
      meta: { title: "情报专家", description: "情报专家" },
    },

    {
      path: "/info/apply",
      name: "infoApply",
      component: infoApplyPage,
      meta: { title: "申请成为情报员", description: "申请成为情报员" },
    },
    {
      path: "/info/myLevel",
      name: "infoMyLevel",
      component: myLevelPage,
      meta: { title: "我的等级", description: "我的等级" },
    },
    {
      path: "/info/myIncome",
      name: "infoMyIncomePage",
      component: myIncomePage,
      meta: { title: "我的收益", description: "我的收益" },
    },
    {
      path: "/info/incomeDetail/:month",
      name: "infoIncomeDetailPage",
      component: incomeDetailPage,
      meta: { title: "收益明细", description: "收益明细" },
    },
    {
      path: "/info/condition",
      name: " infoCondition",
      component: infoConditionPage,
      meta: { title: "申请成为情报员", description: "申请成为情报员" },
    },
    {
      path: "/listItem/shenYc",
      name: "listItemShenYc",
      component: (resolve) => require(["@/views/listItem/shenYc"], resolve),
      meta: { title: "神预测" },
    },
    {
      path: "/listItem/special",
      name: "listItemSpecial",
      component: (resolve) => require(["@/views/listItem/special"], resolve),
      meta: { title: "专题" },
    },
    {
      path: "/listItem/specialArea2",
      name: "listItemSpecialArea2",
      component: (resolve) =>
        require(["@/views/listItem/specialArea2"], resolve),
      meta: { title: "专区" },
    },
    {
      path: "/listItem/specialArea",
      name: "listItemSpecialArea",
      component: (resolve) =>
        require(["@/views/listItem/specialArea"], resolve),
      meta: { title: "专题专区" },
    },
    {
      path: "/listItem/oldNewspaper",
      name: "oldNewspaper",
      component: (resolve) =>
        require(["@/views/listItem/oldNewspaper"], resolve),
      meta: { title: "体坛老刊" },
    },
    {
      path: "/shop",
      name: "shop",
      component: shopPage,
      meta: { title: "商城", description: "商城" },
    },
    {
      path: "/shop/detail",
      name: "shopDetail",
      component: shopDetailPage,
      meta: { title: "商品详情", description: "商品详情" },
    },
    {
      path: "/shop/shareDetail",
      name: "shopShareDetail",
      component: shopShareDetailPage,
      meta: { title: "分享商品详情", description: "分享商品详情" },
    },
    {
      path: "/shop/order",
      name: "shopOrder",
      component: shopOrderPage,
      meta: { title: "订单详情", description: "订单详情" },
    },
    {
      path: "/shop/orderList",
      name: "shopOrderList",
      component: shopOrderListPage,
      meta: { title: "订单列表", description: "订单列表" },
    },
    {
      path: "/shop/shopSearch",
      name: "shopSearch",
      component: shopSearchPage,
      meta: { title: "搜索商品", description: "搜索商品" },
    },
    {
      path: "/titanNewspapers",
      name: "titanNewspapers",
      component: titanNewspapersPage,
      meta: { title: "体坛老刊", description: "体坛老刊" },
    },
  ],
});
import {stat} from '@/util/stat'

let descriptionEle = '';
let metaList = document.getElementsByTagName("meta");
for (let i = 0; i < metaList.length; i++) {
  if (metaList[i].getAttribute("name") == "description") {
    descriptionEle = metaList[i];
  }
}
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  if (to.meta.description) {
    descriptionEle.content = to.meta.description;
  }
  next()
})
router.afterEach((to, form) => {
  stat();
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js